module.exports = __webpack_public_path__ + "static/img/pic_14@2x.34f35361.png";